import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button'; // TODO: FORM-629 Analytics:
// import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
// import { sendAnalytics } from '../../../common/utils';

import messages from './messages';
export var ClearSelectedItemsButton = function ClearSelectedItemsButton(_ref) {
  var onClear = _ref.onClear;
  // const { createAnalyticsEvent } = useAnalyticsEvents();
  var onClearSelectedItems = useCallback(function () {
    // sendAnalytics({
    //   actionSubjectId: 'filterSearchClearSelectedItems',
    //   createAnalyticsEvent,
    //   type,
    // });
    onClear && onClear();
  }, [onClear]);
  return /*#__PURE__*/React.createElement(Button, {
    onClick: onClearSelectedItems,
    appearance: "subtle-link",
    testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.clearAllSelectedItemsButtonText));
};
export default ClearSelectedItemsButton;